import { useState } from "react";
import { Tag, Ruler, CalendarDays } from "lucide-react";
import { SettingsSectionNav } from "./SettingsSectionNav";
import { MealTagsSection } from "./MealTagsSection";
import { IngredientUnitsSection } from "./IngredientUnitsSection";
import { MealPlanSection } from "./MealPlanSection";

const sections = [
  { id: "meal-plan", label: "Meal Plan", icon: CalendarDays },
  { id: "meal-tags", label: "Meal Tags", icon: Tag },
  { id: "ingredient-units", label: "Ingredient Units", icon: Ruler },
];

export function SettingsLayout() {
  const [activeSection, setActiveSection] = useState("meal-plan");

  return (
    <div className="h-full flex flex-col">
      <div className="px-4 md:px-8 pt-6 md:pt-8 pb-4 border-b border-gray-100">
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage your account preferences
        </p>
      </div>

      <div className="flex-1 flex flex-col md:flex-row overflow-auto">
        <SettingsSectionNav
          sections={sections}
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />

        <div className="flex-1 p-4 md:p-8">
          {activeSection === "meal-plan" && <MealPlanSection />}
          {activeSection === "meal-tags" && <MealTagsSection />}
          {activeSection === "ingredient-units" && <IngredientUnitsSection />}
        </div>
      </div>
    </div>
  );
}
